import TalentListPage from '../components/Talent/TalentListPage'

const EmployeesAll = () => {
  return (
    <>
      <title>All Employees | Talent Service</title>
      <TalentListPage
        talentType="employee"
        pageTitle="All Employees"
        pageDescription="View all employees including inactive and terminated ones"
        useAllEmployeesEndpoint={true}
      />
    </>
  )
}

export default EmployeesAll

